// DRAFT — Pending legal review
import React from 'react';

const SalesTerms = () => {
  return (
    <div className="max-w-[680px] mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold text-sage mb-2">Salgsbetingelser for Coord AS</h1>
      <p className="text-sm text-text-muted mb-10">Sist oppdatert: 11. mai 2026</p>

      {/* 1. Generelt */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">1. Generelt</h2>
        <p className="text-text-primary leading-relaxed mb-3">
          Disse salgsbetingelsene gjelder for abonnement på Coord, en digital tjeneste levert av Coord AS (org.nr. 933 971 376), Askimveien 932, 1811 Askim. Tjenesten er tilgjengelig på app.coord.no.
        </p>
        <p className="text-text-primary leading-relaxed mb-3">
          Coord er en digital veiledningstjeneste som hjelper foreldre med barn med særlige behov å navigere Navs støtteordninger. Tjenesten gir tilgang til AI-assistert veiledning om rettigheter og stønader, verktøy for å generere søknader (som hjelpestønad), og ressurser som sjekklister og veiledningsdokumenter.
        </p>
        <p className="text-text-primary leading-relaxed">
          Ved å opprette et abonnement godtar du disse salgsbetingelsene. Betingelsene er utformet i henhold til anbefalingene fra Forbrukertilsynet.
        </p>
      </section>

      {/* 2. Kontaktinformasjon */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">2. Kontaktinformasjon</h2>
        <p className="text-text-primary leading-relaxed">
          Firma: Coord AS
          <br />Organisasjonsnummer: 933 971 376
          <br />Adresse: Askimveien 932, 1811 Askim
          <br />E-post: <a href="mailto:support@coord.no" className="text-primary hover:underline">support@coord.no</a>
          <br />Nettside: <a href="https://www.coord.no" className="text-primary hover:underline">www.coord.no</a>
        </p>
      </section>

      {/* 3. Abonnement og pris */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">3. Abonnement og pris</h2>
        <p className="text-text-primary leading-relaxed mb-3">
          Coord tilbys som et månedlig abonnement til 299 kr per måned (inkl. mva.). Prisen inkluderer merverdiavgift (mva.) der det er aktuelt.
        </p>
        <p className="text-text-primary leading-relaxed">
          Abonnementet løper til det sies opp av deg eller Coord AS. Coord AS forbeholder seg retten til å endre prisen med minimum 30 dagers varsel. Ved prisendring vil du bli varslet per e-post, og du kan si opp abonnementet før den nye prisen trer i kraft.
        </p>
      </section>

      {/* 4. Betaling */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">4. Betaling</h2>
        <p className="text-text-primary leading-relaxed">
          Betaling skjer via Vipps gjentakende betaling. Ved oppstart av abonnementet opprettes en betalingsavtale i Vipps. Beløpet trekkes automatisk fra din Vipps-konto hver måned på avtaledatoen. Dersom en betaling ikke kan gjennomføres (for eksempel ved manglende dekning), vil Vipps forsøke å trekke beløpet på nytt i opptil 14 dager. Du vil motta varsel fra Vipps om den mislykkede betalingen. Hvis betalingen ikke går gjennom i denne perioden, kan Coord begrense eller stenge tilgangen til tjenesten inntil betaling er mottatt.
        </p>
      </section>

      {/* 5. Levering */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">5. Levering</h2>
        <p className="text-text-primary leading-relaxed mb-3">
          Ved betaling får du tilgang til tjenesten. Din bruker er personlig og knyttet til din Vipps-innlogging, og tilgangen skal ikke deles med andre.
        </p>
        <p className="text-text-primary leading-relaxed">
          Abonnementet gir deg digital tilgang til alle funksjoner i Coord, inkludert AI-assistert samtale om rettigheter og stønader, søknadsgenerering for hjelpestønad, nedlastbare ressurser, og personlig tilpasset veiledning basert på din familiesituasjon.
        </p>
      </section>

      {/* 6. Angrerett */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">6. Angrerett</h2>
        <p className="text-text-primary leading-relaxed">
          I henhold til angrerettloven har du 14 dagers angrerett fra den dagen abonnementet ble inngått. For å bruke angreretten må du gi oss melding om det før fristen utløper, enten via e-post til <a href="mailto:support@coord.no" className="text-primary hover:underline">support@coord.no</a> eller ved å si opp betalingsavtalen i Vipps-appen. Dersom du har tatt tjenesten i bruk i angrerettperioden (for eksempel startet samtaler eller generert søknader), samtykker du til at tjenesten leveres før angrefristen utløper. Dersom du benytter angreretten etter å ha tatt tjenesten i bruk, kan Coord kreve betalt for tjenester som er levert før melding om bruk av angreretten er sendt. Ved gyldig bruk av angreretten vil eventuelt innbetalt beløp fratrukket eventuell forholdsmessig betaling bli tilbakebetalt innen 14 dager.
        </p>
      </section>

      {/* 7. Oppsigelse */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">7. Oppsigelse</h2>
        <p className="text-text-primary leading-relaxed">
          Du kan si opp abonnementet når som helst, enten ved å stoppe betalingsavtalen i Vipps-appen eller ved å kontakte oss på <a href="mailto:support@coord.no" className="text-primary hover:underline">support@coord.no</a>. Oppsigelsen får virkning fra utløpet av inneværende betalingsperiode. Du beholder tilgang til tjenesten ut perioden du har betalt for. Coord AS kan si opp avtalen med 30 dagers varsel. Ved misbruk av tjenesten kan tilgangen stenges umiddelbart.
        </p>
      </section>

      {/* 8. Tjenestens innhold og begrensninger */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">8. Tjenestens innhold og begrensninger</h2>
        <p className="text-text-primary leading-relaxed mb-3">
          Coord gir veiledning og verktøy basert på tilgjengelig informasjon om offentlige regelverk og ordninger.
        </p>
        <p className="text-text-primary leading-relaxed mb-3">
          AI-assistenten gir svar basert på offentlige lover, forskrifter og retningslinjer. Informasjonen kan inneholde feil, være ufullstendig eller utdatert. Du er selv ansvarlig for å kontrollere informasjon mot offisielle kilder før du tar beslutninger.
        </p>
        <p className="text-text-primary leading-relaxed">
          Tjenesten erstatter ikke juridisk eller annen rådgivning, og Coord AS garanterer ikke at søknader generert gjennom tjenesten vil bli innvilget av instansen som skal saksbehandle søknaden din.
        </p>
      </section>

      {/* 9. Ansvar */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">9. Ansvar</h2>
        <p className="text-text-primary leading-relaxed">
          Coord AS er ikke ansvarlig for verken direkte eller indirekte tap som følge av bruk av tjenesten eller informasjon gitt gjennom tjenesten.
        </p>
      </section>

      {/* 10. Personvern */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">10. Personvern</h2>
        <p className="text-text-primary leading-relaxed">
          Coord AS behandler personopplysninger i henhold til personopplysningsloven og GDPR. For fullstendig informasjon om hvordan vi behandler personopplysninger, se vår <a href="/privacy" className="text-primary hover:underline">personvernerklæring</a> på app.coord.no/privacy.
        </p>
      </section>

      {/* 11. Klagehåndtering og konfliktløsning */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-sage mb-3">11. Klagehåndtering og konfliktløsning</h2>
        <p className="text-text-primary leading-relaxed">
          Dersom du er misfornøyd med tjenesten, ber vi deg kontakte oss på <a href="mailto:support@coord.no" className="text-primary hover:underline">support@coord.no</a>. Vi vil behandle klagen din innen 14 virkedager. Hvis vi ikke kommer til enighet, kan du klage til Forbrukertilsynet (forbrukertilsynet.no) eller bruke den europeiske klageportalen for netthandel (ec.europa.eu/odr).
        </p>
      </section>

      {/* 12. Endringer i vilkårene */}
      <section className="mb-10">
        <h2 className="text-xl font-semibold text-sage mb-3">12. Endringer i vilkårene</h2>
        <p className="text-text-primary leading-relaxed">
          Coord AS kan oppdatere disse salgsbetingelsene. Ved vesentlige endringer vil du bli varslet per e-post minimum 30 dager før endringene trer i kraft. Fortsatt bruk av tjenesten etter at endringene har trådt i kraft, innebærer aksept av de nye vilkårene.
        </p>
      </section>

      {/* Footer */}
      <footer className="border-t border-border-light pt-6 text-sm text-text-muted">
        <p>Coord AS | Org.nr: 933 971 376 | <a href="mailto:support@coord.no" className="text-primary hover:underline">support@coord.no</a></p>
      </footer>
    </div>
  );
};

export default SalesTerms;
